/**
 * @flow
 * @relayHash c2b6057b4fe74a36f1611a36a0b19a42
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteAccountMutationVariables = {|
  id: string
|};
export type DeleteAccountMutationResponse = {|
  +deleteAccount: {|
    +id: string
  |}
|};
export type DeleteAccountMutation = {|
  variables: DeleteAccountMutationVariables,
  response: DeleteAccountMutationResponse,
|};
*/


/*
mutation DeleteAccountMutation(
  $id: String!
) {
  deleteAccount(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteAccount",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "AccountModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteAccountMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteAccountMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteAccountMutation",
    "id": null,
    "text": "mutation DeleteAccountMutation(\n  $id: String!\n) {\n  deleteAccount(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '36df690eeee02b4948123a5cbfe7ab95';
module.exports = node;
